/******************************** Import Package ************************************/
import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

/******************************** ActionButton Style ************************************/
const StyledButton = styled(Button)(({ theme, ownerState }) => ({
  minWidth: 0,
  margin: theme.spacing(0.5),
  ...(ownerState.color === "secondary" && {
    backgroundColor: theme.palette.secondary.light,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: "#ffffff",
    },
  }),
  ...(ownerState.color === "primary" && {
    backgroundColor: "#4e9a98",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#87bcb4",
    },
  }),
}));

/******************************** ActionButton ************************************/
export default function ActionButton(props) {
  const { color, children, onClick, disabled, className, ...rest } = props;

  return (
    <StyledButton
      ownerState={{ color }}
      disabled={disabled}
      onClick={onClick}
      className={className}
      {...rest}
    >
      {children}
    </StyledButton>
  );
}
